import { render } from "./UserInfo.vue?vue&type=template&id=4a84bc98"
import script from "./UserInfo.vue?vue&type=script&lang=js"
export * from "./UserInfo.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projects\\unistroy\\market\\market-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__